<template>
  <v-container fluid>
    <div v-if="loading">
      <v-row justify="center">
        <v-col cols="12" sm="12" md="10" lg="9" xl="8">
          <div v-for="index in 10" :key="index">
            <v-divider class="mb-3 mt-3" v-if="index !== 1"></v-divider>
            <v-card elevation="2" class="px-3 py-2">
              <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row justify="center">
        <v-col cols="12" sm="12" md="10" lg="9" xl="8">
          <div class="text-h1 mb-2" @mouseenter="showEditar = true" @mouseleave="showEditar = false">
            Chamado <b>#{{chamado.cha_id}}</b>
            <v-chip v-if="chamado.cha_status == 0" color="red">Aberto</v-chip>
            <v-chip v-if="chamado.cha_status == 1" color="primary">Em Andamento</v-chip>
            <v-chip v-if="chamado.cha_status == 2" color="green">Finalizado</v-chip>
            <v-tooltip bottom v-if="showEditar">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openChamado()" color="primary" class="ml-2">
                  edit
                </v-icon>
              </template>
              <span>Editar Chamado</span>
            </v-tooltip>
          </div>
          <div class="text-small mb-4">
            Aberto por: <b v-if="chamado && chamado.usuario">{{chamado.usuario.usu_nome}}</b>
          </div>
          <div class="mt-2">
            <vue-editor :class="$vuetify.theme.dark ? 'dark_theme' : ''" v-model="chamadoDesc" :loading="salvando" :disabled="true" :editorOptions="editorOptionsPreview"></vue-editor>
          </div>
          <div class="text-small mb-4">
            <b v-if="chamado && chamado.cliente">{{chamado.cliente.cli_nome}},</b> {{moment(chamado.cha_criado_em).format('DD/MM/YYYY [às] HH:mm[hrs]')}}
          </div>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogNovo"
        persistent
        max-width="600px"
      >
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              {{chamado.uuid_cha_id ? 'Editar' : 'Novo'}} chamado
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="dialogNovo = false">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-form ref="formChamado">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="chamadoEdita.uuid_cli_id"
                  :items="clientes"
                  clearable
                  clear-icon="close"
                  label="Cliente*"
                  :rules="[rules.required]"
                  append-icon="expand_more"
                  :loading="salvando || loadingClientes"
                  :disabled="salvando || loadingClientes"
                  outlined
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                <!-- <v-textarea
                  outlined
                  autofocus
                  no-resize
                  rows="3"
                  v-model="chamadoEdita.cha_descricao"
                  :rules="[rules.required]"
                  label="Descrição*"
                ></v-textarea> -->
                <vue-editor :class="$vuetify.theme.dark ? 'dark_theme' : ''" v-model="chamadoEdita.cha_descricao" :loading="salvando" :disabled="salvando" :editorToolbar="customToolbar"></vue-editor>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="chamadoEdita.cha_status"
                  :items="statusChamado"
                  label="Status*"
                  append-icon="expand_more"
                  :loading="salvando"
                  :disabled="salvando"
                  outlined
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
          <v-divider></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              :disabled="salvando"
              :loading="salvando"
              @click="dialogNovo = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="saveEditChamado()"
              :loading="salvando"
              :disabled="salvando"
            >
              Salvar
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-row justify="center" v-if="loadingComentarios">
        <v-col cols="12" sm="12" md="10" lg="9" xl="8">
          <div v-for="index in 10" :key="index">
            <v-divider class="mb-3 mt-3" v-if="index !== 0"></v-divider>
            <v-card elevation="2" class="px-3 py-2">
              <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" v-else>
        <v-col cols="12" sm="12" md="10" lg="9" xl="8">
          <div class="text-h3 text-primary mb-3">
            {{comentarios.length}} {{comentarios.length === 1 ? 'Interação' : 'Interações'}}
          </div>
          <div v-for="(item, index) in comentarios" :key="index">
            <v-divider class="mb-3 mt-3" v-if="index !== 0"></v-divider>
            <v-card elevation="2" class="px-5 py-4">
              <v-row>
                <v-col cols="12" sm="12" md="3" lg="2" xl="2" class="text-left">
                  <v-row align="center">
                    <v-col cols="12" sm="3" md="5" lg="5" xl="4">
                      <div class="avatar" :style="`background-image: url('${item && item.usuario.usu_imagem ? item.usuario.usu_imagem : require('@/assets/img/logo-icon.png')}')`"></div>
                    </v-col>
                    <v-col cols="12" sm="9" md="7" lg="7" xl="8" class="pl-0 pt-0 pr-0">
                      <div class="text mt-3">{{item.usuario.usu_nome}}</div>
                      <div class="text-very-small mt-2">
                        {{item.cco_criado_em}}
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="9" lg="10" xl="10">
                  <div class="text mt-1 comentario" v-html="item.cco_comentario">
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="10" md="10" lg="9" xl="8">
          <v-card class="px-4 py-2">
            <div class="text-h2 text-primary mb-3">
              Nova interação
            </div>
            <vue-editor :class="$vuetify.theme.dark ? 'dark_theme' : ''" v-model="comentario.cco_comentario" :loading="salvando" :disabled="salvando" :editorToolbar="customToolbar"></vue-editor>
            <v-divider class="mt-2 mb-2"></v-divider>
            <v-row no-gutters class="mb-0" align="center" justify="space-between">
              <v-col cols="12" sm="6" md="6" lg="4" xl="3" class="pb-0 pt-0 pl-0 mt-3">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="comentario.cha_status"
                  :items="statusChamado"
                  label="Status do chamado*"
                  hide-details=""
                  append-icon="expand_more"
                  :loading="salvando"
                  :disabled="salvando"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-btn
                color="primary"
                :loading="salvando"
                :disabled="salvando"
                @click="salvaComentario()"
              >
                Salvar
              </v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import { VueEditor } from 'vue2-editor'
export default {
  components: {
    VueEditor
  },
  data () {
    return {
      loading: true,
      uuid: '',
      clientes: [],
      dialogNovo: false,
      comentarios: [],
      loadingComentarios: false,
      loadingClientes: false,
      salvando: false,
      showEditar: false,
      comentario: {
        cha_status: '',
        cco_comentario: ''
      },
      editorOptionsPreview: {
        modules: {
          toolbar: false
        }
      },
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['clean']
      ],
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      chamadoDesc: '',
      statusChamado: [
        {
          text: 'Aberto',
          value: 0
        },
        {
          text: 'Em andamento',
          value: 1
        },
        {
          text: 'Finalizado',
          value: 2
        }
      ],
      chamado: {
        cha_status: 0,
        cha_descricao: ''
      },
      chamadoEdita: {
        cha_status: 0,
        cha_descricao: ''
      }
    }
  },
  methods: {
    moment,
    loadFunctions () {
      this.getClientes()
      this.getChamado()
      this.getComentarios()
    },
    async getClientes () {
      this.loadingClientes = true
      await Api.get('clientes')
        .then(res => {
          var arrayCli = []
          res.data.map(cli => {
            arrayCli.push({
              'text': cli.cli_nome,
              'value': cli.uuid_cli_id
            })
          })
          this.clientes = arrayCli
          this.loadingClientes = false
        })
        .catch(err => {
          this.loadingClientes = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os clientes!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getChamado () {
      this.loading = true
      Api.get('chamados/' + this.uuid)
        .then((response) => {
          this.loading = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.chamado = JSON.parse(JSON.stringify(response.data))
          this.chamadoDesc = this.chamado.cha_descricao
          if (response.data.cliente) {
            this.chamado.uuid_cli_id = response.data.cliente.uuid_cli_id
          }
          this.comentario.cha_status = this.chamado.cha_status
        })
        .catch((error) => {
          this.loading = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do chamado!',
            color: 'error'
          })
        })
    },
    openChamado () {
      this.chamadoEdita = JSON.parse(JSON.stringify(this.chamado))
      this.dialogNovo = true
    },
    saveEditChamado () {
      if (!this.$refs.formChamado.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'chamados/novo'
      if (this.chamadoEdita.uuid_cha_id) {
        endpoint = 'chamados/edita'
      }
      Api.post(endpoint, this.chamadoEdita)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.dialogNovo = false
          this.getChamado()
          this.$root.SnackControl.open(this, {
            text: 'Chamado atualizado com sucesso!',
            color: 'success'
          })
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    getComentarios () {
      this.salvando = true
      this.loadingComentarios = true
      Api.get('chamados/' + this.uuid + '/comentarios')
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          let cha = []
          if (response.data.length) {
            response.data.map(item => {
              item.cco_criado_em = item.cco_criado_em ? moment(item.cco_criado_em).format('DD/MM/YYYY [às] HH:mm[hrs]') : ''
            })
            cha = response.data
          }
          this.comentarios = cha
          this.loadingComentarios = false
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar os comentários!',
            color: 'error'
          })
        })
    },
    salvaComentario () {
      if (this.comentario.cco_comentario.length < 17) {
        this.$root.SnackControl.open(this, {
          text: 'Comentário deve conter no mínimo 10 dígitos',
          color: 'error'
        })
        return false
      }
      this.salvando = true
      Api.post('chamados/' + this.uuid + '/comentarios/novo', this.comentario)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Comentário cadastrado com sucesso!',
            color: 'success'
          })
          this.chamado.cha_status = this.comentario.cha_status
          this.comentario.cco_comentario = ''
          this.getComentarios()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    }
  },
  created () {
    this.uuid = this.$route.params.uuid
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.dark_theme {
  >>> .ql-snow .ql-stroke {
    stroke: white!important;
  }
  >>> .ql-active {
    stroke: $primary!important
  }
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  height: 40px;
  margin: 0 auto;
  width: 40px;
}
.text-very-small {
  font-size: 10px;
}
.comentario {
  margin-bottom: 10px;
  min-height: 60px;
}
.text-small {
  font-size: 14px;
}
.borda_descricao {
  border: 1px $primary solid;
  padding: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/chamados/Chamado.vue